export default [
  {
    type: 'input',
    placeholder: '设备型号',
    filed: 'model',
    default: ''
  },
  {
    type: 'select',
    placeholder: '间室',
    filed: 'type',
    default: '',
    options: [
      {
        code: '0018yquwclzb4otl',
        name: '一室酒柜'
      },
      {
        code: '0028yquwclzb4otl',
        name: '两室酒柜'
      }
    ]
  }
]
